import React from 'react';
import styles from './segmented.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Port of lt-components LTSegmentedControl (spec §panelLayout): bordered
 * group, muted option background, selected option = white card with its own
 * border. Icon-only when options carry icons.
 */
export function SegmentedControl(_ref) {
  var options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange,
    ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/_jsx("div", {
    className: styles.group,
    role: "tablist",
    "aria-label": ariaLabel,
    children: options.map(function (opt) {
      var _opt$icon;
      var selected = opt.value === value;
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        role: "tab",
        "aria-selected": selected,
        "aria-label": opt.label,
        className: "".concat(styles.option, " ").concat(opt.icon ? styles.optionIcon : '', " ").concat(selected ? styles.optionSelected : ''),
        onClick: function onClick() {
          return onChange(opt.value);
        },
        children: (_opt$icon = opt.icon) !== null && _opt$icon !== void 0 ? _opt$icon : opt.label
      }, opt.value);
    })
  });
}

/** Screenshot-mode icon (quoted image-screenshot.svg, stroke #57606a). */
export var ScreenshotModeIcon = function ScreenshotModeIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 13.25 13.25",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12.625 8.6245L10.57 6.5665C10.3197 6.31644 9.98033 6.17598 9.6265 6.17598C9.27268 6.17598 8.93332 6.31644 8.683 6.5665L2.626 12.625M11.2915 0.625H1.96C1.6062 0.625 1.26686 0.765445 1.01654 1.01548C0.766224 1.26552 0.625398 1.6047 0.625 1.9585V11.2915C0.625 12.028 1.222 12.625 1.9585 12.625H11.2915C12.028 12.625 12.625 12.028 12.625 11.2915V1.96C12.625 1.6062 12.4846 1.26686 12.2345 1.01654C11.9845 0.766224 11.6453 0.625398 11.2915 0.625ZM4.6255 5.9575C4.97917 5.9575 5.31835 5.81701 5.56843 5.56693C5.81851 5.31685 5.959 4.97767 5.959 4.624C5.959 4.27033 5.81851 3.93115 5.56843 3.68107C5.31835 3.43099 4.97917 3.2905 4.6255 3.2905C4.27183 3.2905 3.93265 3.43099 3.68257 3.68107C3.43249 3.93115 3.292 4.27033 3.292 4.624C3.292 4.97767 3.43249 5.31685 3.68257 5.56693C3.93265 5.81701 4.27183 5.9575 4.6255 5.9575Z",
      stroke: "#57606a",
      strokeWidth: "1.25",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

/** Video-mode icon (quoted monitor-play.svg, stroke #57606a). */
export var VideoModeIcon = function VideoModeIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 15.4318 14.25",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.0795 13.625H5.35227M13.8068 11.2614H1.625C1.07271 11.2614 0.625 10.8137 0.625 10.2614V1.625C0.625 1.07272 1.07271 0.625 1.625 0.625H13.8068C14.3591 0.625 14.8068 1.07271 14.8068 1.625V10.2614C14.8068 10.8137 14.3591 11.2614 13.8068 11.2614ZM6.21591 7.83973V4.04672C6.21591 3.84705 6.43845 3.72795 6.60458 3.83871L9.44934 5.73521C9.59778 5.83417 9.59778 6.05228 9.44934 6.15124L6.60458 8.04775C6.43845 8.1585 6.21591 8.03941 6.21591 7.83973Z",
      stroke: "#57606a",
      strokeWidth: "1.25",
      strokeLinecap: "round"
    })
  });
};